module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }), _vm._v(" "), _c('section', {
    staticClass: "epHeader"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "meta"
  }, [_c('span', [(_vm.episodeNumber) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " • ")]) : _vm._e(), _vm._v(_vm._s(_vm.formattedPubDate))])]), _vm._v(" "), _c('p', {
    staticClass: "actions"
  }, [_c('a', {
    attrs: {
      "href": "#comments"
    }
  }, [_vm._v(_vm._s(_vm.comments) + " Comments")]), _vm._v(" "), _c('span', [_vm._v("Share\n            "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/home?status=' + encodeURI(_vm.episode.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:twitter"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Twitter")])], 1), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(_vm.episode.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:facebook-f"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Facebook")])], 1)])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-podcast-in-app"
  }, [_c('p', [_vm._v("Find this episode in your podcast app here!")]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": "https://pod.link/412457621"
    }
  }, [_vm._v("\n              Subscribe\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e4a54a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/episode/Hero.vue
// module id = 769
// module chunks = 1